import React from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-dropdown-select";
import { calendarOptions } from "../../../_helpers";

export function CalendarTemplatePage({ onSubmit, formRef, store }) {
  const formMethods = useForm({
    defaultValues: {
      template: store.template || "gregorian",
    },
  });

  const { control, handleSubmit } = formMethods;

  return (
    <div className="chronos-calendar-template-page">
      {/* <FormProvider {...formMethods}> */}
      <form onSubmit={handleSubmit(onSubmit)} ref={formRef}>
        <h2 className="chronos-wizard-page-title">Choose Calendar Template</h2>
        <p className="chronos-wizard-text">
          Your calendar defines how time is divided in your Chronicle.
        </p>
        <p className="chronos-wizard-text">
          Select a calendar template. You can customize everything in the next
          steps.
        </p>
        <div className="form-group">
          <Controller
            name="template"
            control={control}
            render={({ value, onChange }) => {
              let defVal = calendarOptions.find((o) => o.value === value);
              if (!defVal)
                defVal = calendarOptions.find((o) => o.value === "gregorian");
              return (
                <Select
                  options={calendarOptions}
                  values={[defVal]}
                  onChange={(val) => onChange(val[0].value)}
                  dropdownGap={0}
                  labelField="name"
                  valueField="value"
                  className="chronos-select"
                />
              );
            }}
          />
        </div>
      </form>
      {/* </FormProvider> */}
    </div>
  );
}
// <select
//   value={value}
//   onChange={onChange}
//   className="form-control"
//   style={{ width: "30rem" }}
// >
//   {calendarOptions.map((option) => (
//     <option key={option.value} value={option.value}>
//       {option.name}
//     </option>
//   ))}
// </select>
